import { HttpResponse, httpService } from '../core/http'
import {
  DetailPaginatedRequest,
  PaginatedRequest,
  PaginatedResponseData
} from '../core/interfaces'
import { Contract, ContractFilter, Opportunity } from '../entities'

export const getAllContracts = async (
  query: PaginatedRequest<ContractFilter>
): Promise<PaginatedResponseData<Contract>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get('/contracts', {
      params: {
        ...query
      }
    })

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getContractById = async (id: string): Promise<Contract> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(`/contracts/${id}`)
    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getContractOpportunities = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<Opportunity>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/contracts/${query?.id}/opportunities`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getContractItems = async (
  query: DetailPaginatedRequest
): Promise<PaginatedResponseData<Contract>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/contracts/${query?.id}/items`,
      { params: { ...query } }
    )
    return httpResponse.data
  } catch (error) {
    return error
  }
}
